import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ConfigurationService } from '../_services/configuration.service';
import { MatSort, MatPaginator, MatTableDataSource } from '@angular/material';
import { AppConfig, ExcelService } from '../_helpers/index';
import { Router } from '@angular/router';
import { DataService } from '../_helpers/dataservice.service'
import { AuthService } from '../_services/auth.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { CustomerService } from '../_services/customer.service';

@Component({
    selector: 'companies',
    templateUrl: './companieslist.component.html',
    styleUrls: ['../../assets/css/customer-list-table.css']
})
export class CompaniesListComponent implements OnInit {

    public customer_public_id: string;
    excelExportData: any;
    ddldbtTipo: any[];
    ddldbdocumenttype: any[];

    auth0Profile: any;

    searchFilterForm: FormGroup;
    displayedColumns: string[] = ['document_id', 'name', 'contact', 'email', 'phone'];
    dataSourceCompany = new MatTableDataSource();
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    filterValue;

    pageSize: number;
    PageSizeOptions: number[];
    isLoading = true;

    paginatorIntl: any;

    constructor
        (
            private configurationService: ConfigurationService
            , private formBuilder: FormBuilder
            , private excelService: ExcelService
            , private dataService: DataService
            , private router: Router
            , private auth: AuthService
            , private spinnerService: Ng4LoadingSpinnerService
            , private customerService: CustomerService
        ) {
        this.spinnerService.show();
        this.pageSize = AppConfig.settings.gridPageSetting.PageSize;
        this.PageSizeOptions = AppConfig.settings.gridPageSetting.PageSizeOptions;

    }//end cons

    applyFilter() {

        this.filterValue = this.searchFilterForm.controls.searchText.value;
        this.filterValue = this.filterValue.trim();
        this.filterValue = this.filterValue.toLowerCase();
        this.dataSourceCompany.filter = this.filterValue;
    }

    ngOnInit() {

        this.paginator._intl.itemsPerPageLabel = "Registros por página";
        this.paginator._intl.nextPageLabel = "siguiente página";
        this.paginator._intl.lastPageLabel = "última página";
        this.paginator._intl.previousPageLabel = "anterior página";
        this.paginator._intl.firstPageLabel = "primera página";


        let browserStorage = (typeof localStorage === 'undefined') ? null : localStorage;
        if (browserStorage == null) {
            this.router.navigate(['/login']);
        }
        else {
            this.customer_public_id = browserStorage.getItem('companyId');
        }

        this.searchFilterForm = this.formBuilder.group({
            searchText: ['', Validators.required]
        });

        this.GetCompanyDetails();
        this.dataSourceCompany.paginator = this.paginator;
        this.dataSourceCompany.sort = this.sort;
    }

    GetCompanyDetails() {
        this.configurationService.getCustomerCompaniesList(this.customer_public_id).subscribe(data => {
            if (data["data"].length !== 0 && data["data"][0]["values"] != undefined) {
                let resources = data["data"][0]["values"];
                this.dataSourceCompany.data = resources;
                this.excelExportData = resources;
            }
            this.spinnerService.hide();
        },
            error => {
                console.log('Failed while trying to the Customer Companies List. ' + error);
            });
    }//end



    viewDashboard(element) {
        localStorage.setItem('isCorporateCompany', "Yes");
        localStorage.removeItem('accessmenu');
        this.GetSubCompanyName(element);
        localStorage.setItem('subcompanyId', element.public_id);
        this.router.navigate([`/dashboardcallback`]);
    }//end

    GetSubCompanyName(element) {

        this.customerService.getCustomerCompanyDetailsList(element.public_id).subscribe(d => {
            
            localStorage.setItem('isCorporate', 'Yes');
            localStorage.setItem('customername', d.body.name);
            this.dataService.changeuserprofilename(localStorage.getItem('customername'));
        },
            error => {

            });

    }

}//end class


